function getHash() {
    return window.location.hash.slice(1);
}

function getIsPointerSupported() {
    return typeof window !== 'undefined' && 'onpointerdown' in window;
}

export {getHash, getIsPointerSupported};
